import React from 'react';
import { useTheme } from 'styled-components';
import type { AssetTypeEnum } from 'venn-api';
import { type FeatureName, FundUtils, useHasFF } from 'venn-utils';
import { IconWithTooltip } from '../icon-with-tooltip';

interface AssetBadgeProps {
  assetType: AssetTypeEnum;
  size?: number;
  className?: string;
}

const AssetBadge: React.FC<AssetBadgeProps> = ({ assetType, className, size = 12 }) => {
  const { Images } = useTheme();
  const assetConfig = FundUtils.getAssetTypeConfig(assetType);

  const iconImg = assetConfig.badge?.getIcon?.(Images);
  const requiredFF = assetConfig.badge?.featureFlag;
  const hasRequiredFF = useHasFF((requiredFF || '') as FeatureName);

  if (!iconImg || (requiredFF && !hasRequiredFF)) {
    return null;
  }

  return (
    <IconWithTooltip
      iconImg={iconImg}
      width={size}
      height={size}
      tooltipText={assetConfig.tooltip}
      className={className}
      alt=""
    />
  );
};

export default AssetBadge;
